import { render } from "./App.vue?vue&type=template&id=efd6f4ee"
const script = {}

import "./App.vue?vue&type=style&index=0&id=efd6f4ee&lang=css"

import exportComponent from "/Users/apple/Sandbox/RSM/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__